import React, { Component } from 'react';
import Sidebar from '../../common/Sidebar';
import Topbar from '../../common/Topbar';
import UnitsTabs from './unitstopmenu';
import Grouping from './unitgrouping';
import ListCities from '../CityMaster/listCities';
import ListStates from '../CityMaster/listStates';
import ListCountries from '../CityMaster/listCountries';
import ListUnits from './listunits';
import Employees from './listemployees'
import {
    BrowserRouter as Router,
} from 'react-router-dom';
import * as Constants from '../../common/Global/constants';
import { isEmptyVariable,getLocalStorageVariables,getThemeSettingsVariables, handleTokenExpiry } from '../../common/Global/commonFunctions';
import ListProjects from './listprojects';
let userDetails = getLocalStorageVariables();
let themeSettings = getThemeSettingsVariables();
class ClientsMain extends Component {
    constructor(props) {
        super(props);
        this.state = {
            unitId:"",
            empHeaderText:"",
            companyId:"",
            companyType:"",
            displayingUnits:false,
            displayingProjects:false,
            displayingEmployees:false,
            displayCards:true,
            displayingGrouping:false,
            displayingCities:false,
            displayingStates:false,
            showCityMaster:false,
            displayingCountries:false,
            showProject:false,
            showEmployee:false,
            isShowProject:false,
            componentDidMountFlag:false,
        }
        userDetails = getLocalStorageVariables();
        themeSettings = getThemeSettingsVariables();
    }

    // This function to handle click events on the Employees dropdown
    viewEmployeesDropDownItemClick = (unitId,empHeaderText) => {
        this.setState({
            unitId:unitId,
            showProject:false,
            showEmployee:true,
            empHeaderText:empHeaderText,
            displayingUnits:false,
            displayingProjects:false,
            displayingEmployees:true,
            displayingGrouping:false,
            displayingCities:false,
            displayingStates:false,
            displayingCountries:false
        })
    }

    // This function to handle click events on the Employees tab
    employeesTabItemOnClick = (unitId) => {
        this.setState({
            unitId:unitId,
            displayingUnits:false,
            displayingProjects:false,
            displayingEmployees:true,
            displayingGrouping:false,
            displayingCities:false,
            displayingStates:false,
            displayingCountries:false
        })
    }

    viewProjectsDropDownItemClick = (companyId) => {
        this.setState({
            companyId:companyId,
            showProject:true,
            showEmployee:false,
            displayingUnits:false,
            displayingProjects:true,
            displayingEmployees:false,
            displayingGrouping:false,
            displayingCities:false,
            displayingStates:false,
            displayingCountries:false
        })
    }

    projectTabItemOnClick = () => {
        this.setState({
            displayingUnits:false,
            displayingProjects:true,
            displayingEmployees:false,
            displayingGrouping:false,
            displayingCities:false,
            displayingStates:false,
            displayingCountries:false
        })
    }

    // This function to handle click events on the Units tab
    unitTabItemOnClick = () =>{
        this.setState({
            showEmployee:false,
            showProject:false,
            displayingUnits:true,
            companyType:this.state.companyType,
            displayingProjects:false,
            displayingEmployees:false,
            displayingGrouping:false,
            displayingCities:false,
            displayingStates:false,
            displayingCountries:false
        })
    }  
    
    // This function to handle click events on the Grouping tab
    gropingTabItemOnClick = () =>{
        this.setState({
            displayingUnits:false,
            displayingProjects:false,
            displayingEmployees:false,
            displayingGrouping:true,
            displayingCities:false,
            displayingStates:false,
            displayingCountries:false
        })
    }

    // This function to handle click events on the City tab
    cityTabItemOnClick = () => {
        this.setState({
            displayingGrouping:false,
            displayingUnits:false,
            displayingProjects:false,
            displayingEmployees:false,
            displayingCities:true,
            displayingStates:false,
            displayingCountries:false
        })
    }

    // This function to handle click events on the State/Province tab
    stateTabItemOnClick = () => {
        this.setState({
            displayingGrouping:false,
            displayingCompanies:false,
            displayingUnits:false,
            displayingProjects:false,
            displayingEmployees:false,
            displayingCities:false,
            displayingStates:true,
            displayingCountries:false
        })
    }

    // This function to handle click events on the Country tab
    countryTabItemOnClick = () => {
        this.setState({
            displayingGrouping:false,
            displayingCompanies:false,
            displayingUnits:false,
            displayingProjects:false,
            displayingEmployees:false,
            displayingCities:false,
            displayingStates:false,
            displayingCountries:true
        })
    }

    toggleCardsDisplay = () => {
        this.setState({
            displayCards:!this.state.displayCards
        })
    }

    componentDidMount(){
        this.initData();
    }

    initData = () => {
        fetch(Constants.GetUserMenu,
        {
            method: "POST",
            mode:'cors',
            body: new URLSearchParams({
                email:userDetails.email,
                accessToken:userDetails.accessToken,
            })
        })
        .then(response => { return response.json(); } )
        .then(data =>
        {
            if(handleTokenExpiry(data.responseCode)) return;
            else if(data.responseCode === Constants.CODE_SUCCESS){
                let companyId = data.data.company.companyId;
                let companyType = data.data.company.companyType
                let otherSettings = data.data.otherSettings
                let clientAuditType = data.data.clientAuditType;
                let clientId = data.data.user.clientId;
                let isShowProject = clientAuditType?.some(item => item.clientId == clientId && item.auditType == "Project");

                let showCityMaster = otherSettings?.some(item => 
                    item.settingColumn === "cityTransfer" && item.settingColumnEnabled === "Y")
                this.setState({
                    companyId:companyId,
                    companyType: companyType,
                    showCityMaster:showCityMaster,
                    isShowProject:isShowProject,
                    displayingUnits:true,
                    componentDidMountFlag:true,
                })
            }else{
            }
        });
    }

    render() {
        return(
            <Router>
                <main className="main-dashboard">
                    <section className="dashboard-bg">
                        <Sidebar />

                        <div className="dashboard-right-bg position-relative">
                            <div className="dashboard-wrapper">
                                <Topbar />
                                {this.state.componentDidMountFlag &&
                                <UnitsTabs 
                                    unitId = {this.state.unitId}
                                    showProject={this.state.showProject}
                                    showEmployee={this.state.showEmployee}
                                    companyId={this.state.companyId}
                                    
                                    isShowProject={this.state.isShowProject}
                                    displayingUnits = {this.state.displayingUnits}
                                    displayingProjects={this.state.displayingProjects}
                                    displayingEmployees = {this.state.displayingEmployees}
                                    displayingGrouping = {this.state.displayingGrouping}
                                    displayingCities={this.state.displayingCities}
                                    displayingStates={this.state.displayingStates}
                                    displayingCountries={this.state.displayingCountries}
                                    showCityMaster={this.state.showCityMaster}

                                    unitTabItemOnClick = {this.unitTabItemOnClick}
                                    projectTabItemOnClick = {this.projectTabItemOnClick}
                                    employeesTabItemOnClick = {this.employeesTabItemOnClick}
                                    gropingTabItemOnClick = {this.gropingTabItemOnClick}
                                    cityTabItemOnClick={this.cityTabItemOnClick}
                                    stateTabItemOnClick={this.stateTabItemOnClick}
                                    countryTabItemOnClick={this.countryTabItemOnClick}
                                    toggleCardsDisplay = {this.toggleCardsDisplay}
                                    themeSettings = {themeSettings}
                                />
                                }

                                {
                                    this.state.displayingUnits &&
                                    <ListUnits 
                                        onlyParent={true}
                                        companyType={this.state.companyType}
                                        companyId={this.state.companyId}
                                        isShowProject={this.state.isShowProject}
                                        viewEmployeesDropDownItemClick = {this.viewEmployeesDropDownItemClick}
                                        viewProjectsDropDownItemClick={this.viewProjectsDropDownItemClick}
                                        displayCards={this.state.displayCards}
                                        themeSettings = {themeSettings}
                                    />
                                }
                                {
                                    !isEmptyVariable(this.state.unitId) &&
                                    this.state.displayingEmployees &&
                                    <Employees 
                                        unitId = {this.state.unitId}
                                        empHeaderText = {this.state.empHeaderText}
                                        displayCards={this.state.displayCards}
                                        themeSettings = {themeSettings}
                                        companyId={this.state.companyId}
                                    />
                                }
                                {
                                    !isEmptyVariable(this.state.companyId) &&
                                    this.state.displayingProjects &&
                                    <ListProjects
                                        companyId = {this.state.companyId}
                                        displayCards={this.state.displayCards}
                                        themeSettings = {themeSettings}
                                    />
                                }
                                {this.state.displayingGrouping && 
                                    <Grouping />
                                }
                                {this.state.displayingCities &&
                                    <ListCities />
                                }
                                {this.state.displayingStates &&
                                    <ListStates />
                                }
                                {this.state.displayingCountries &&
                                    <ListCountries />
                                }
                            </div>
                        </div>
                    </section>
                </main>
            </Router>
        )
    }
}

export default ClientsMain;

